/**
 * Convert a `File` object returned by the upload input into a base 64 string.
 * That's not the most optimized way to store images in production, but it's
 * enough to illustrate the idea of data provider decoration.
 */
const convertFileToBase64 = file => new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file.rawFile);

    reader.onload = () => resolve(reader.result);
    reader.onerror = reject;
});

/**
 * For posts update only, convert uploaded image in base 64 and attach it to
 * the `picture` sent property, with `src` and `title` attributes.
 */
const convertFileList = (list) => {
    const files = list || [];
    const formerPictures = files.filter(p => !(p.rawFile instanceof File));
    const newPictures = files.filter(p => p.rawFile instanceof File);
    if (!newPictures.length) {
        return Promise.resolve(files);
    }
    return Promise.all(newPictures.map(convertFileToBase64))
        .then(base64Pictures => base64Pictures.map((picture64, index) => ({
            src: picture64,
            title: `${newPictures[index].title}`,
        })))
        .then(transformedNewPictures => [...transformedNewPictures, ...formerPictures]);
};

const addUploadFeature = requestHandler => (type, resource, params) => {
    if ((type === 'UPDATE' || type === 'CREATE') && (resource === 'vehicle_models' || resource === 'tour_names' )) {
        const keys = resource === 'vehicle_models' ? ['files', 'files_l', 'files_r'] : ['files'];
        const hasNewFile = keys.some((key) => (params.data[key] || []).some((file) => file.rawFile instanceof File));
        if (hasNewFile) {
            return Promise.all(keys.map((key) => convertFileList(params.data[key])))
                .then((converted) => {
                    const data = { ...params.data };
                    keys.forEach((key, index) => {
                        if (params.data[key]) data[key] = converted[index];
                    });
                    return requestHandler(type, resource, { ...params, data });
                });
        }
    }
    return requestHandler(type, resource, params);
};

export default addUploadFeature;


// WEBPACK FOOTER //
// ./src/dataProvider/addUploadFeature.js